import styled from "styled-components"

interface ImageProps {
  alt: string
  src: string
  height?: string | number
  width?: string | number
  $align?: string
}

interface ImageBoxProps {
  $align?: string
}
const ImageComponent = styled.img.attrs((props) => ({
  alt: props.alt,
  src: props.src,
}))`
  height: ${(props) => props.height || undefined};
  max-height: ${(props) => props.height || undefined};
  width: ${(props) => props.width || undefined};
  max-width: ${(props) => props.width || undefined};
  width: "100%";
  height: 100%;
`
const ImageBox = styled.div<ImageBoxProps>`
  display: flex;
  align-items: center;
  justify-content: ${({ $align }: any) => ($align ? $align : "center")};
  object-fit: contain;
`

export const Image = (props: ImageProps) => {
  return (
    <ImageBox $align={props.$align}>
      <ImageComponent {...props} loading="lazy" />
    </ImageBox>
  )
}

export default Image
